<template>
  <div class="box">
    <div class="banner">
      <img :src="banner" alt="">
        <router-link  :to="{path:'/league',query: {sysTtype:sysTtype}}"><div class="banner-btn">申请试用</div></router-link>
    </div>
    <div class="center-box center clearfix">
      <div class="indexCase clearfix">
        <div class="indexTitle-box">
          <h5 class="indexTitle">WHAT CAN WE DO</h5>
          <h6 class="indexSubtitle">我们能做什么</h6>
          <div class="select-head">
              <ul>
                <li @click="selectItem(1)" style="margin-left:0px;">
                  <div class="fl-item fl" :class="selectIndex==1?'center-act-img':''">
                    
                    <div class="img-box" :class="selectIndex==1?'img-box-act':''" >
                        <img v-if="selectIndex==1" src="../assets/images/rescue_act1.png" alt="">
                        <img v-if="selectIndex!=1" src="../assets/images/rescue_1.png" alt="">
                    </div>
                  </div>
                  <div class="fr-item fr" :class="selectIndex==1?'fr-item-act':''">  
                    <div class="fr-item-text" :class="selectIndex==1?'fr-item-text-act':''">
                      <div class="lh">事件监控</div>
                      <div class="fr-item-info" :class="selectIndex==1?'center-act':''">大屏幕展示出团情况,事件信息</div>
                    </div>
                    <span class="line"></span>
                  </div>      
                </li>
                <li @click="selectItem(2)" >
                  <div class="fl-item fl" :class="selectIndex==2?'center-act-img':''">
                    
                    <div class="img-box" :class="selectIndex==2?'img-box-act':''" >
                        <img v-if="selectIndex==2" src="../assets/images/rescue_act2.png" alt="">
                        <img v-if="selectIndex!=2" src="../assets/images/rescue_2.png" alt="">
                    </div>
                  </div>
                  <div class="fr-item fr" :class="selectIndex==2?'fr-item-act':''">  
                    <div class="fr-item-text" :class="selectIndex==2?'fr-item-text-act':''">
                      <div class="lh">应急方案</div>
                      <div class="fr-item-info" :class="selectIndex==2?'center-act':''">自动生成,灵活实用</div>
                    </div>
                    <span class="line"></span>
                  </div>      
                </li>
                <li @click="selectItem(3)" >
                  <div class="fl-item fl" :class="selectIndex==3?'center-act-img':''">
                    
                    <div class="img-box" :class="selectIndex==3?'img-box-act':''" >
                        <img v-if="selectIndex==3" src="../assets/images/rescue_act3.png" alt="">
                        <img v-if="selectIndex!=3" src="../assets/images/rescue_3.png" alt="">
                    </div>
                  </div>
                  <div class="fr-item fr" :class="selectIndex==3?'fr-item-act':''">  
                    <div class="fr-item-text" :class="selectIndex==3?'fr-item-text-act':''">
                      <div class="lh">事件处理</div>
                      <div class="fr-item-info" :class="selectIndex==3?'center-act':''">联合行动,便捷高效</div>
                    </div>
                    <span class="line"></span>
                  </div>      
                </li>
                <li @click="selectItem(4)" >
                  <div class="fl-item fl" :class="selectIndex==4?'center-act-img':''">
                    
                    <div class="img-box" :class="selectIndex==4?'img-box-act':''" >
                        <img v-if="selectIndex==4" src="../assets/images/rescue_act4.png" alt="">
                        <img v-if="selectIndex!=4" src="../assets/images/rescue_4.png" alt="">
                    </div>
                  </div>
                  <div class="fr-item fr" :class="selectIndex==4?'fr-item-act':''">  
                    <div class="fr-item-text" :class="selectIndex==4?'fr-item-text-act':''">
                      <div class="lh">公告处理</div>
                      <div class="fr-item-info" :class="selectIndex==4?'center-act':''">信息直达导游、游客</div>
                    </div>
                    <span class="line"></span>
                  </div>      
                </li>
                <li @click="selectItem(5)" >
                  <div class="fl-item fl" :class="selectIndex==5?'center-act-img':''">
                    
                    <div class="img-box" :class="selectIndex==5?'img-box-act':''" >
                        <img v-if="selectIndex==5" src="../assets/images/rescue_act5.png" alt="">
                        <img v-if="selectIndex!=5" src="../assets/images/rescue_5.png" alt="">
                    </div>
                  </div>
                  <div class="fr-item fr" :class="selectIndex==5?'fr-item-act':''">  
                    <div class="fr-item-text" :class="selectIndex==5?'fr-item-text-act':''">
                      <div class="lh">事件报告</div>
                      <div class="fr-item-info" :class="selectIndex==5?'center-act':''">上通下达,快速提交</div>
                    </div>
                    <span class="line"></span>
                  </div>      
                </li>
                <li @click="selectItem(6)" >
                  <div class="fl-item fl" :class="selectIndex==6?'center-act-img':''">
                    
                    <div class="img-box" :class="selectIndex==6?'img-box-act':''" >
                        <img v-if="selectIndex==6" src="../assets/images/rescue_act6.png" alt="">
                        <img v-if="selectIndex!=6" src="../assets/images/rescue_6.png" alt="">
                    </div>
                  </div>
                  <div class="fr-item fr" :class="selectIndex==6?'fr-item-act':''">  
                    <div class="fr-item-text" :class="selectIndex==6?'fr-item-text-act':''">
                      <div class="lh">通讯录</div>
                      <div class="fr-item-info" :class="selectIndex==6?'center-act':''">内部、外部联络方式</div>
                    </div>
                    <span class="line" style="width:2px;"></span>
                  </div>      
                </li>
                <li @click="selectItem(7)" >
                  <div class="fl-item fl" :class="selectIndex==7?'center-act-img':''">
                    
                    <div class="img-box" :class="selectIndex==7?'img-box-act':''" >
                        <img v-if="selectIndex==7" src="../assets/images/rescue_act7.png" alt="">
                        <img v-if="selectIndex!=7" src="../assets/images/rescue_7.png" alt="">
                    </div>
                  </div>
                  <div class="fr-item fr" :class="selectIndex==7?'fr-item-act':''">  
                    <div class="fr-item-text" :class="selectIndex==7?'fr-item-text-act':''">
                      <div class="lh">数据查询</div>
                      <div class="fr-item-info" :class="selectIndex==7?'center-act':''">快速查询,灵活导出</div>
                    </div>
                  </div>      
                </li>
            
              </ul>
          </div>
          <div class="select-center">
            <div class="select-pai" v-if="selectIndex==1">
              <div class="select-img-box"><img src="../assets/images/rescue_sys_1.jpg" alt="" style="width:80%;"></div>
              <router-link  :to="{path:'/league',query: {sysTtype:sysTtype}}"><div class="btn">申请试用</div></router-link>
            </div>
            <div class="select-pai" v-if="selectIndex==2">
              <div class="select-img-box"><img src="../assets/images/rescue_sys_1.jpg" alt="" style="width:80%;"></div>
              <router-link  :to="{path:'/league',query: {sysTtype:sysTtype}}"><div class="btn">申请试用</div></router-link>
            </div>
            <div class="select-pai" v-if="selectIndex==3">
              <div class="select-img-box"><img src="../assets/images/rescue_sys_1.jpg" alt="" style="width:80%;"></div>
              <router-link  :to="{path:'/league',query: {sysTtype:sysTtype}}"><div class="btn">申请试用</div></router-link>
            </div>
            <div class="select-pai" v-if="selectIndex==4">
              <div class="select-img-box"><img src="../assets/images/rescue_sys_1.jpg" alt="" style="width:80%;"></div>
              <router-link  :to="{path:'/league',query: {sysTtype:sysTtype}}"><div class="btn">申请试用</div></router-link>
            </div>
            <div class="select-pai" v-if="selectIndex==5">
              <div class="select-img-box"><img src="../assets/images/rescue_sys_1.jpg" alt="" style="width:80%;"></div>
              <router-link  :to="{path:'/league',query: {sysTtype:sysTtype}}"><div class="btn">申请试用</div></router-link>
            </div>
            <div class="select-pai" v-if="selectIndex==6">
              <div class="select-img-box"><img src="../assets/images/rescue_sys_1.jpg" alt="" style="width:80%;"></div>
              <router-link  :to="{path:'/league',query: {sysTtype:sysTtype}}"><div class="btn">申请试用</div></router-link>
            </div>
            <div class="select-pai" v-if="selectIndex==7">
              <div class="select-img-box"><img src="../assets/images/rescue_sys_1.jpg" alt="" style="width:80%;"></div>
              <router-link  :to="{path:'/league',query: {sysTtype:sysTtype}}"><div class="btn">申请试用</div></router-link>
            </div>


          </div>

        </div>


      </div>    
    </div>

    <div class="ApplicationForm">

      <!-- <div class="center clearfix">
        <div class="indexCase">
          <div class="indexTitle-box">
            <h5 class="indexTitle">申请流程</h5>
            <h6 class="indexSubtitle">Application process</h6>
          </div>
          <ul class="indexService">
            <li class="indexService-li">
              <img :src="ApplicationFormIcon+'1.png'" alt="">
              <div class="advantage-text">
                <h6>资格认证</h6>
                <p>进行实名认证后，再进行达人认证资料提交，提交后等待平台审核。</p>
              </div>
            </li>
            <li class="indexService-li2"></li>
            <li class="indexService-li">
              <img :src="ApplicationFormIcon+'2.png'" alt="">
              <div class="advantage-text">
                <h6>资质审核</h6>
                <p>位讯平台将尽快审核您提交的资料，安排专人和您联系，打电话以了解更多信息。 </p>
              </div>
              
            </li>
            <li class="indexService-li2"></li>
            <li class="indexService-li">
              <img :src="ApplicationFormIcon+'3.png'" alt="">
              <div class="advantage-text">
                <h6>完成认证</h6>
                <p>审核通过后，即完成认证，您就可以在位讯平台上发布您的个性化服务或者收到来自旅客的导游预约。</p>
              </div>
              
            </li>
          </ul>
        </div>
      </div> -->
    </div>
    <div class="flow">
      <img :src="flow" alt=""> 
    </div>

    <div class="pay-flow">  
      <router-link  :to="{path:'/league',query: {sysTtype:sysTtype}}"><div class="tryout">申请试用</div></router-link>
    </div>
    <!-- <div class="center clearfix">
      <div class="indexCase clearfix">
        <div class="indexTitle-box">
          <h5 class="indexTitle">谁能加入我们</h5>
        </div>
        <div class="JoinUs clearfix">
          <span class="JoinUs-l fl"></span>
          <span class="JoinUs-r fr"></span>
          <p class="JoinUs-text">您可以是专业资深的导游，也可以是一个热爱旅行的达人，只要您乐于接待游客，提供贴心舒适的服务，都可以加入位讯旅游</p>
          <a :href="href" class="JoinUs-Btn">申请加入位讯</a>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
  import global_ from './../store/global'
export default {
  name: 'Cooperation',
  data () {
    return {

      sendSelected:'cooperation',
      colourClass:'',
      banner:  global_.imgUrl+'resuce_banner.jpg',
      flow:  global_.imgUrl+'flow.jpg',
      advantageIcon:  global_.imgUrl+'advantage-icon',
      ApplicationFormIcon:  global_.imgUrl+'ApplicationFormIcon',
      href:'#/cooperation/register',
      selectIndex:'1',
      sysTtype:4,

    }
  },
  methods: {
    selectItem(index){
      this.selectIndex=index
    },
  },

  beforeMount(){
    var session=sessionStorage.getItem('GWcustomer');
    if(session!=null){
      this.href='#/cooperation/information';
    }

  },
  mounted(){
    this.$emit('nav',this.sendSelected,this.colourClass);
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .banner{
    width: 100%;
    height: 700px;
    min-width: 1200px;
    position: relative;
    overflow: hidden;
    img{
      width: 1920px;
      max-width: inherit;
      position: relative;
      left: 50%;
      top: 0;
      margin-left: -960px;
    }
    .banner-btn{
      position: absolute;
      top: 200px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      width: 200px;
      height:50px;
      line-height: 50px;
      text-align: center;
      margin:auto;
      color: #fff;
      background: linear-gradient(to right, #09ba7e 0%,#09bab1 100%);
      border-radius: 4px;
      cursor: pointer;
    }
  }
  .flow{
    width: 100%;
    height: 400px;
    min-width: 1200px;
    position: relative;
    overflow: hidden;
    img{
      width: 1920px;
      max-width: inherit;
      position: relative;
      left: 50%;
      top: 0;
      margin-left: -960px;
    }
  }

  .pay-flow{
    width: 100%;
    height: 690px;
    min-width: 1200px;
    position: relative;
    overflow: hidden;
    background: #00bff6 url('../assets/images/resuce_price.jpg') center center no-repeat;
    .tryout{
      position: absolute;
      top: 520px;
      bottom: 0px;
      left: 0px;
      right:0px;
      margin: auto;
      width:200px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: #fff;
      background: linear-gradient(to right, #09ba79 0%,#09bab2 100%);
      border-radius: 4px;
      cursor: pointer;
    }
  }
  .center-box{
    width: 100%;
    height: 890px;
  }

  .indexCase{
    margin: 80px 0 140px;
    .indexTitle-box{
      margin-bottom: 40px;
      text-align: center;
      .indexTitle{
        font-size: 32px;
        font-weight: bold;
        color: #cdeddd;
        line-height: 40px;
      }
      .indexSubtitle{
        font-size: 24px;
        color: #585858;
        line-height: 32px;
        font-weight: normal;
        text-transform:uppercase;
        margin: 5px 0;
      }
    }

    .indexService{
      margin: 60px 0 0;
      display: flex;
      .indexService-li{
        // flex-grow: 1;
        text-align: center;
        width: 25%;
        img{
          display: block;
          margin: 30px auto 20px;
        }
        .advantage-text{
          margin: 0 20px;
          h6{
            font-size: 20px;
            line-height: 28px;
            color: #333; 
            margin-bottom: 10px;
            // text-indent: 15px;
          }
          p{
            font-size: 14px;
            line-height: 24px;
            color: #999; 
          }
        }
        
      }
    }
    
  }
  .ApplicationForm{
    background: #00bff6 url('../assets/images/resuce_promise.jpg') center center no-repeat;
    width: 100%;
    height: 600px;
    min-width: 1200px;
    .indexCase{
      margin: 80px 0;
    }
    .indexTitle-box{
      .indexTitle,.indexSubtitle{
        color: #fff;
      }
      
    }
    .indexService{
      
      .indexService-li{
        .advantage-text{
          h6{
            color: #fff; 
          }
          p{
            color: #fff; 
          }
        }
      }
    }

    
  }
  .JoinUs{
    span{
      width: 18px;
      height: 18px;
      border: 2px solid #ff0000;
      border-bottom:none;
      &.JoinUs-l{
        border-right: none;
      }
      &.JoinUs-r{
        border-left: none;
      }
    }
    .JoinUs-text{
      font-size: 14px;
      color: #333;
      margin: 25px;
      text-align: center;
      line-height: 24px;
    }
    .JoinUs-Btn{
      display: block;
      width: 260px;
      height: 60px;
      text-align: center;
      line-height: 60px;
      border-radius: 10px;
      margin: 0 auto;
      background-color: #ff8c00;
      font-size: 20px;
      color: #fff;
      margin-top: 80px;
      &:hover{
        background-color: #fe981b;
      }
    }
  }
  .select-head{
    color: #363636;
    margin-top: 20px;
    position: relative;
    width: 100%;
    background-color: tan;
    ul{   
      list-style-type:none;
      width: 1000px;
      background-color: #eee;
      position: absolute;
      left: 0px;
      right: 0px;
      bottom: 0px;
      top: 20px;
      margin: auto;
      li{
        float: left;
        margin-left: 26px;
        cursor: pointer;
        .fl-item{
          position: relative;
            img{
            width: 40%;
            } 
          .img-box{
            position: absolute;
            width: 70px;
            height: 70px;
            top: 0px;
            left: -8px;
            img{
            width: 40%;
            }  
          }
          .img-box-act{
            top: -10px;
          }
        }
     
        .fr-item{
          position: relative;
          padding-left: 50px;
          .lh{
            line-height: 25px;
          }
          .line{
            position: absolute;
            right: -20px;
            top: 0px;
            display: block;
            width: 1px;
            height: 30px;
            background-color: #09ba79;
          }
          .fr-item-text{
            position: relative;
            top:0px;
            
          }       
          .fr-item-text-act{
            position: relative;
            top:-10px;    
          }       
        }
        .fr-item-act{
          padding-left: 60px;
          text-align: left;
        }
        .fr-item-info{
            margin-top: 10px;
            font-size: 12px;
            color: #999999;
          }
        .fr-item-info{
          display: none;
        }
        .center-act{
          display: block;
          margin-top:10px;
          margin-bottom: 10px;
        }
        .center-act-img .img-box img{
          width: 80%;
        }
        .img-box{

        }
        // &:hover .lh{
        //     line-height: 0px;
        // }
        // &:hover .fr-item-info{
        //     display: block;
        //     margin-top:15px;
        // }
        // &:hover img{
        //     width: 80%;
        // }
      }
    }
  }
  .select-center{
    width: 1000px;
    height: 520px;
    margin: 0px auto;
    margin-top: 100px;
    background-color: #f5f5f5;
    .select-pai{
      position: relative;
      width: 100%;
      height:100%;
      // background: url('../assets/images/pai.png') center 20px no-repeat;
      background-size: 100%;
      .select-img-box{
        position: absolute;
        top: 0px; 
        left: 0px;
        right: 0px;
        bottom:0px;
        margin: auto;
        width: 550px;
        height: 320px;
      }
      .btn{
        width: 90px;
        height: 30px;
        position: absolute;
        left: 0;
        right: 0px;
        top: 380px;
        bottom: 0px;
        margin: auto;
        line-height: 30px;
        color: #5dcfa5;
        text-align: center;
        border-radius: 4px;
        border: 1px solid #5dcfa5;
        cursor: pointer;
      }
    }



  }

</style>



// WEBPACK FOOTER //
// src/components/rescue.vue